<template>
	<div class="drawer-container-overflow" v-if="!loading">
		<template v-if="devices.length > 0">
			<plan-device-row v-for="device in devices" :key="device.id"
			                 placementOnly
			                 :placed="placed"
			                 :planId="planId"
			                 :device="device"
			                 :selectedDevice="selectedDevice"
			                 @selectDevice="selectDevice"
			                 @removeDevice="removeDeviceFromPlan"></plan-device-row>
		</template>
		<p v-else class="text-xs mb-0">{{ textEmpty }}</p>
	</div>

	<div class="calendar-overlay opacity-100 fixed z-50 w-full h-full" v-else>
		<div class="h-full w-full flex items-center justify-center">
			<md-progress-spinner class="md-white" md-mode="indeterminate"
			                     :md-diameter="65" :md-stroke="5"></md-progress-spinner>
		</div>
	</div>
</template>

<script>
import PlanDeviceRow from "../../../Sites/Devices/Plans/components/PlanDeviceRow";
export default {
	name: "SitePlanDrawerContainer",
	components: {
		PlanDeviceRow
	},
	props: {
		devices: Array,
		planId: Number,
		selectedDevice: Object,
		placed: {
			type: Boolean,
			default() {
				return false
			}
		},
		textEmpty: String
	},
	data() {
		return {
			loading: true,
			timeout: null
		}
	},
	methods: {
		selectDevice(e) {
			this.$emit('selectDevice', e)
		},
		removeDeviceFromPlan(e) {
			this.$emit('removeDevice', e)
		}
	},
	mounted() {
		this.timeout = setTimeout(() => {
			this.loading = false
		}, 500)
	},
	beforeDestroy() {
		clearTimeout(this.timeout)
	}
}
</script>

<style scoped>

</style>
